import { Component } from '@angular/core';
import { CalendarComponentOptions } from 'ion2-calendar'
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { GlobalVars } from '../../app/app.environment';
import { AbsenceMotives } from '../../models/absence-motives';
import { PetitionTypes } from '../../models/petition-types';
import { AuthProvider } from '../../providers/auth/auth';
import { NotificationProvider } from '../../providers/notification/notification';
import { PetitionProvider } from '../../providers/petition/petition';
import { UserProvider } from '../../providers/user/user';


@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {

  dateMulti: string[] = [];
  optionsMulti: CalendarComponentOptions = {
    from: new Date(2000, 0),
    pickMode: 'multi',
    weekdays: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    weekStart: 1,
    monthFormat: 'MMMM YYYY',
    monthPickerFormat: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    daysConfig: [],
  };

  public alertaAreas;

  currentExtraHours;
  currentPendingHolidays;
  currentPendingAPs;

  previousPendingHolidays;
  previousPendingAPs;

  private userSubscription;
  private petitionsSubscription;


  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public globalVars: GlobalVars,
    public authProvider: AuthProvider,
    public userProvider: UserProvider,
    public petitionProvider: PetitionProvider,
    public notificationProvider: NotificationProvider
  ) {
    this.getUserInfo();
    this.getPetitions();
    notificationProvider.initNotifications();
  }

  ionViewWillLeave() {
    if (this.userSubscription && !this.userSubscription.closed) this.userSubscription.unsubscribe();
    if (this.petitionsSubscription && !this.petitionsSubscription.closed) this.petitionsSubscription.unsubscribe();
  }

  getUserInfo() {
    this.userSubscription = this.userProvider.getUserData().subscribe(user => {
      if (user) {
        this.globalVars.user.extraHours = user.extraHours;
        this.globalVars.user.pendingAPs = user.pendingAPs;
        this.globalVars.user.pendingHolidays = user.pendingHolidays;
        this.globalVars.user.area = user.area;
        this.globalVars.user.areaId = user.areaId;
  
        this.currentExtraHours = this.globalVars.user.extraHours;
        this.currentPendingHolidays = this.globalVars.user.pendingHolidays ? this.globalVars.user.pendingHolidays[this.globalVars.currentPeriod] : null
        this.currentPendingAPs = this.globalVars.user.pendingAPs ? this.globalVars.user.pendingAPs[this.globalVars.currentPeriod] : null

        this.previousPendingHolidays = this.globalVars.user.pendingHolidays ? this.globalVars.user.pendingHolidays[this.globalVars.currentPeriod-1] : null
        this.previousPendingAPs = this.globalVars.user.pendingAPs ? this.globalVars.user.pendingAPs[this.globalVars.currentPeriod-1] : null

        //if(this.globalVars.user.role == Role.admin) this.checkAreas();  
      }
    })
  }

  getPetitions() {
    this.petitionsSubscription = this.petitionProvider.getUserAcceptedCalendar().subscribe(petitions => {
      
      console.log(petitions)
      this.dateMulti = [];
      this.optionsMulti.daysConfig = [];

      petitions.forEach(petition => {
        if (petition.state == 'Aceptado' && petition.annulment == false) {
          console.log('omplir')
          this.addToCalendar(petition);
        }
  
        else if (petition.state == 'Aceptado' && petition.annulment == true) {
          console.log('buidar')
          this.removeFromCalendar(petition);
        }
      })
      
      console.log(this.dateMulti);
    })
  }

  addToCalendar(petition) {
    if (petition.typeId == PetitionTypes.hourCompensation || petition.motiveKey == AbsenceMotives.holidays) {
      var startDate = new Date(petition.beginDate);
      var endDate = new Date(petition.endDate);
    
      var curDate = startDate;
      while (curDate <= endDate) {
        /*
        let date = curDate.toLocaleDateString().split('/');
        date[1] = Number(date[1]) > 9 ? date[1] : 0 + date[1]; 
        this.dateMulti.push(date[2] + '-' + date[1] + '-' + date[0]);
        */
        
        this.dateMulti.push(curDate.toDateString());
        curDate.setDate(curDate.getDate() + 1);
      }
    }

    else this.dateMulti.push(petition.date);
  }

  removeFromCalendar(petition) {
    if (petition.typeId == PetitionTypes.hourCompensation || petition.motiveKey == AbsenceMotives.holidays) {
      var startDate = new Date(petition.beginDate);
      var endDate = new Date(petition.endDate);
    
      var curDate = startDate;
      while (curDate <= endDate) {
        this.dateMulti.splice(this.dateMulti.indexOf(petition.date), 1);
        curDate.setDate(curDate.getDate() + 1);
      }
    }
    else {
      this.dateMulti.splice(this.dateMulti.indexOf(petition.date), 1);
    }
  }

  onSelect($event) {
    console.log('onSelect', $event);
  }

  addLabels() {
    this.userProvider.addLabels()
  }

}




// WEBPACK FOOTER //
// ./src/pages/home/home.ts